import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import images from '../../../../services/images';
import ContentHeader from '../../../parts/ContentHeader';
import Layout from '../../../parts/Layout';
import helpers from '../../../../services/helpers';
import { httpRequest, httpAuthHeaders } from '../../../../services/httpService';
import Loader from '../../../parts/Loader';
import initTreeView from '../../../../services/initTreeView';
import ContactListModal from '../../../modals/ContactListModal';
import RenderErrors from '../../../elements/RenderErrors';
import VehiclesSearchModal from '../vehicles/VehiclesSearchModal';
import Swal from 'sweetalert2';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';
import { Calendar } from 'primereact/calendar';
import { Steps } from 'primereact/steps';
import { InputSwitch } from 'primereact/inputswitch';
import { AutoComplete } from 'primereact/autocomplete';
import { InputTextarea } from 'primereact/inputtextarea';
// import { InputGroup } from 'primereact/inputgroup';
// import { InputGroupAddon } from 'primereact/inputgroupaddon';

import { Panel } from 'primereact/panel';
import { 
    FaMapMarkerAlt, FaTruck, FaExchangeAlt,
    FaSearch, FaCalendarAlt, FaBus, FaCreditCard, FaCheckCircle, FaEdit,
    FaChevronLeft, FaChevronRight,
    FaShip, FaCheck, FaReceipt
} from "react-icons/fa";
import { FaFileCircleCheck } from "react-icons/fa6";
import { CiReceipt } from "react-icons/ci";


 
export default function BookingNewForm ({viewer = 'admin', menu = 'manage-bookings', page_title = "New Booking"}){
    const navigate = useNavigate();
    const toast = useRef(null);
    const today = new Date();
    const [loading, setLoading] = useState(0);
    const [errors, setErrors] = useState([]);
    today.setHours(0, 0, 0, 0);
    
    const [bookingDetails, setBookingDetails] = useState([]);
    const [isRebooking, setIsRebooking] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [tripType, setTripType] = useState('one-way');
    const [tripOrigin, setTripOrigin] = useState(null);
    const [tripDestination, setTripDestination] = useState(null);
    const [portList, setPortList] = useState([]);

    const [tripDates, setDates] = useState({
        departure_date: null,
        return_date: null
    });
    const initialDepartureDate = tripDates.departure_date ? new Date(tripDates.departure_date) : new Date();
    const [selectedDepartureDate, setSelectedDepartureDate] = useState(initialDepartureDate);
    const [selectedDepartureID, setSelectDepartureID] = useState(null);

    const initialReturnDate = tripDates.return_date ? new Date(tripDates.return_date) : new Date(new Date().setDate(new Date().getDate() + 1));
    const [selectedReturnDate, setSelectedReturnDate] = useState(initialReturnDate);
    const [selectedReturnID, setSelectReturnID] = useState(null);

    const [isDepartureDateShifted, setIsDepartureDateShifted] = useState(false);
    const [isReturnDateShifted, setIsReturnDateShifted] = useState(false);

    const [customerModal, setContactModal] = useState(0);
    const [saveNewCustomer, setSaveNewCustomer] = useState(false);
    const [sameAsCustomer, setSameAsCustomer] = useState(false);
    const [existingCustomer, setExitingCustomer] = useState([]);
    
    const [customerData, setContactData] = useState({
        "id": "",
        "customer_id": "",
        "contact_name":"",
        "customer_name":"",
        "customer_email":"",
        "customer_phone":"",
        "notes":"",
    });

    const defaultVehicleData = {
        "id": "",
        "vehicle_id": "",
        "item_type": "vehicle",
        "plate_number":"",
        "brand": "",
        "model_name": "",
        "year_model": "",
        "driver": "",
        "price": 0,
    }
    const [vehicleData, setVehicleData] = useState([defaultVehicleData]);
    const [vehicleModal, setVehicleModal] = useState(0);
    const [vehicleIndex, setVehicleIndex] = useState(null);
    const [vehicleErrors, setVehicleErrors] = useState([]);
    const [renderVehicleCards, setRenderVehicleCards] = useState(null);

    const [schedules, setSchedules] = useState([
        { id: 1, departureTime: '06:00 AM', departureCode: 'ORM', arrivalTime: '09:00 AM', arrivalCode: 'CEB', date: '27 Apr (Mon)', eta: '3 hr/s', classType: 'Tourist Class', price: '1,430.00', vesselCode: 'OJ601' },
        { id: 2, departureTime: '09:30 AM', departureCode: 'ORM', arrivalTime: '12:30 PM', arrivalCode: 'CEB', date: '27 Apr (Mon)', eta: '3 hr/s', classType: 'Tourist Class', price: '1,430.00', vesselCode: 'OJ602' },
    ]);

    const [scheduleOptions, setScheduleOptions] = useState({
        departure_schedules: [],
        return_schedules: []
    })
    
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(1);//Cash
    const [receiptNumber, setReceiptNumber] = useState('');
    const [splitPayment, setSplitPayment] = useState([]);//Cash
    const paymentMethodOptions = [
        {
            id: 1,
            method_name: "Cash"
        },
        {
            id: 4,
            method_name: "Check"
        },
        {
            id: 6,
            method_name: "Gcash"
        },
        {
            id: 7,
            method_name: "Maya"
        },
        {
            id: 9,
            method_name: "Split Payment"
        },
        {
            id: 8,
            method_name: "Invoice Payment"
        },
    ]

    const computeTotalPrice = () => {
        return vehicleData.reduce((accumulator, currentItem) => {
            const price = parseFloat(currentItem.price) || 0;
            return accumulator + price;
        }, 0);
    };

    // FIXED: Removed the state setter call from this function
    const computeTotalAmount = () => {
        const tripCount = tripType === 'round-trip' ? 2 : 1;
        const totalPrice = computeTotalPrice();
        return totalPrice * tripCount;
    };
    /**
     * Split
     */

    // 1. Array state tracking every active split-payment line item
    const [paymentRows, setPaymentRows] = useState([
        //{ id: 1, method: 1, amount: null, reference_no: '' }
    ]);

    const methodOptions = [
        { method_name: 'Cash', id: 1 },
        { method_name: 'Credit/Debit Card', id: 2 },
        { method_name: 'Bank Transfer', id: 3 },
        { method_name: 'Check', id: 4 },
        { method_name: 'QR Ph', id: 5 },
        { method_name: 'GCash', id: 6 },
        { method_name: 'Maya', id: 7 },
        //{ method_name: 'GoTyme', id: 9 }
    ];

    // 2. Append a new payment method split row to the state list
    const addNewRow = () => {
        const tempId = `temp-${crypto.randomUUID()}`;
        setPaymentRows([
            ...paymentRows, 
            { id: tempId, method: null, amount: null, reference_no: '' }
        ]);
    };

    // 3. Remove a row by filtering out its unique UUID
    const removeRow = (id) => {
        if (paymentRows.length > 1) {
            setPaymentRows(paymentRows.filter(row => row.id !== id));
        }
    };

    // 4. Update row values. If modifying 'method', change the 'id' to match.
    const updateRowValue = (id, property, value) => {
        const revisedRows = paymentRows.map((row) => {
            if (row.id === id) {
                if (property === 'method') {
                    // Update BOTH id and method properties to ensure parity
                    return { ...row, id: value, method: value };
                }
                return { ...row, [property]: value };
            }
            return row;
        });
        setPaymentRows(revisedRows);
    };

    // --- IMPROVED COMPUTATION & VALIDATION LOGIC ---
    const actualInvoiceTotal = computeTotalAmount(); 
    const allocatedSum = paymentRows.reduce((acc, current) => acc + (current.amount || 0), 0);
    const balanceRemaining = actualInvoiceTotal - allocatedSum;

    // 1. Check if the amounts match perfectly (resolves JS floating-point issues)
    const isAmountMatched = Math.abs(balanceRemaining) < 0.01;

    // 2. Check if every row has a payment method selected (no row is left on the placeholder hint)
    const isEveryMethodSelected = paymentRows.every(row => row.method !== null && row.method !== '');

    // 3. Combined Safeguard: True only if amounts match AND all fields have selected types
    const isSumPerfectMatch = isAmountMatched && isEveryMethodSelected;

    /**
     * End of Split
     */
    
    const itemTemplate = (item, options) => {
        const isActive = options.index === activeIndex;
        const isCompleted = options.index < activeIndex;

        return (
            <div className="d-flex flex-column align-items-center step-item-container" 
                 onClick={options.onClick} 
                 style={{ cursor: 'pointer', marginTop: '-15px' }}>
                {/* The Icon sits below the line relative to the CSS positioning */}
                <div className={`step-icon-circle ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
                    {item.icon}
                </div>
                <span className={`step-label mt-2 ${isActive ? 'text-dark font-weight-bold' : 'text-muted'}`}>
                    {item.label}
                </span>
            </div>
        );
    };
    
    // PrimeReact Steps Items
    const stepItems = [
        { label: 'Search', icon: <FaSearch />, template: itemTemplate },
        { label: 'Schedule', icon: <FaCalendarAlt />, template: itemTemplate },
        { label: 'Vehicle', icon: <FaBus />, template: itemTemplate },
        { label: 'Review', icon: <FaFileCircleCheck  />, template: itemTemplate },
        { label: 'Payment', icon: <FaCreditCard />, template: itemTemplate },
    ];

// Logic to disable "Prev. Day" if selectedDepartureDate is today or earlier
    const isPrevDisabled = selectedDepartureDate <= today;
    const isPrevReturnDisabled = selectedReturnDate <= selectedDepartureDate;

    //Autcomplete
    const [suggestions, setSuggestions] = useState([]);

    useEffect(() => {
        initTreeView()

        const booking_id = helpers.getURLParams('rebook') ?? ''
        if(booking_id){
            fetchBookingData(booking_id)
        }
        else{
            fetchPortList()
        }
    }, []);

    // useEffect(() => {
    //     if(tripType === 'one-way'){
    //         setDates((prev) => {

    //             return {
    //                 ...prev,
    //                 return_date: null
    //             };
    //         });
    //     }
    // }, [tripType]);

    useEffect(() => {
        if(isDepartureDateShifted || isReturnDateShifted){
            handleSearch()
        }
    }, [isDepartureDateShifted, isReturnDateShifted, ]);


    useEffect(() => {
        if(tripDates.departure_date){
            setSelectedDepartureDate(new Date(tripDates.departure_date))
        }
        else{
            setSelectedDepartureDate(new Date())
        }

        if(tripDates.return_date){
            setSelectedReturnDate(new Date(tripDates.return_date))
        }
        else{
            setSelectedReturnDate(new Date(new Date().setDate(new Date().getDate() + 1)))
        }
    }, [tripDates.departure_date, tripDates.return_date]);

    
    function fetchBookingData(id){
        if(!id){
            return
        }
        const url = helpers.createShipBookingHubUrl(`booking/${id}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setLoading(0)

            if(res.is_rebooked){
                Swal.fire({
                    text: 'This booking has already been rebooked.',
                    icon: "error",
                    confirmButtonText: "Refresh",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.replace("/ship-booking/bookings/new")
                    }
                })
            }
            else{
                setBookingDetails(res)
                fetchPortList()

                setTripType('one-way')
                setIsRebooking(true)

                setContactData((prevData) => ({
                    ...prevData,
                    customer_id: res.customer_id,
                    contact_name: res.customer_name,
                    customer_name: res.customer_name,
                    customer_phone: res.customer_phone,
                    customer_email: res.customer_email,
                    notes: `Rebooked from ${res.booking_ref}`
                }));

                const formattedVehicles = extractVehicleDetails(res);
                setVehicleData(formattedVehicles)
            }
        })
        .catch((err) => {
            setLoading(0)
            toast.current.show({
                severity: 'error', 
                summary: 'Notice', 
                detail: err.message, 
                life: 5000 
            });
        }); 

    }
    function extractVehicleDetails(data) {
        // Safe check to ensure details array exists
        if (!data || !Array.isArray(data.details)) {
            return [];
        }

        return data.details.map(item => ({
            id: item.id ?? "",
            vehicle_id: item.item_id ?? "",
            item_type: item.item_type ?? "vehicle",
            plate_number: item.plate_number ?? "",
            brand: item.brand ?? "",
            model_name: item.model_name ?? "",
            year_model: item.year_model ?? "",       // Defaults to empty string if missing
            driver: item.driver ?? "",               // Converts null drivers to empty string
            price: parseFloat(item.unit_price) || 0  // Converts "2000.00" string to number 2000
        }));
    }


    function fetchPortList(){
        setLoading(1)
        const url = helpers.createShipBookingHubUrl(`ports`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setPortList(res)
            setLoading(0)
        })
        .catch((err) => {
            setLoading(0)
            toast.current.show({severity:'error', detail:err.message, life: 5000});
        }); 
    }


    function validateForm(index){
        //let new_errors = {...errors}
        let validationRules = {}
        //new_errors = {}

        let new_errors = {}
        if(index === 0){//Schedule
            new_errors = {}
            validationRules = {
                origin_location: { value: tripOrigin, message: 'Please select origin' },
                destination_location: { value: tripDestination, message: 'Please select destination' },
                departure_date: { value: tripDates.departure_date, message: 'Please select departure date' },
            };

            if(tripType === 'round-trip'){
                validationRules.return_date = { value: tripDates.return_date, message: 'Please select return date' }
            }
        }
        else if(index === 2){//Schedule
            new_errors = {}
            validationRules = {
                customer_name: { value: customerData.customer_name, message: 'Customer is required.' },
                //customer_phone: { value: customerData.customer_phone, message: 'Please select phone' },
            };
        }

        Object.keys(validationRules).forEach(key => {
            const { value, message } = validationRules[key];
            if (!value) {
                new_errors[key] = [message];
            } else {
                delete new_errors[key];
            }
        });

        setErrors(new_errors);

        return new_errors;
    }

    
    const validateVehicles = () => {
        let allVehicleErrors = [];

        vehicleData.forEach((v, index) => {
            let currentErrors = {};

            // 1. Plate Number Validation
            if (!v.plate_number?.trim()) {
                currentErrors.plate_number = ["Please enter plate number"];
            }

            // 2. Brand Validation
            if (!v.brand?.trim()) {
                currentErrors.brand = ["Please enter brand"];
            }

            // 3. Model Name Validation
            if (!v.model_name?.trim()) {
                currentErrors.model_name = ["Please enter model name"];
            }

            if (!v.price || v.price.toString().trim() === "") {
                currentErrors.price = ["Please enter valid price"];
            }

            if (Object.keys(currentErrors).length > 0) {
                allVehicleErrors.push({ index, errors: currentErrors });
            }
        });

        setVehicleErrors(allVehicleErrors);
        
        return allVehicleErrors.length;
    };

    function handleStep(e){
        let index = e.index

        /** SEARCH TRIPS */
        let validate = validateForm(0);
        if(Object.keys(validate).length){
            setActiveIndex(0)
            return
        }

        if(!scheduleOptions?.departure_schedules?.length){
            setErrors([])
            setActiveIndex(0)
            return toast.current.show({
                    severity: 'error', 
                    summary: 'Notice', 
                    detail: 'Please search trips first.', 
                    life: 5000 
                });
        }

        //SCHEDULES
        if (tripType === 'round-trip' && index > 1) {
            if (!selectedDepartureID || !selectedReturnID) {
                toast.current.show({
                    severity: 'error', 
                    summary: 'Notice', 
                    detail: 'Please select both departure and return schedules.', 
                    life: 5000 
                });
            
                setActiveIndex(1)
                return
            }
        } 
        else if (tripType === 'one-way' && index > 1) {
            // One-way validation
            if (!selectedDepartureID) {
                toast.current.show({
                    severity: 'error', 
                    summary: 'Notice', 
                    detail: 'Please select a departure schedule.', 
                    life: 5000 
                });
            
                setActiveIndex(1)
                return
            }
        }

        //VEHICLES
        const validate_customer = validateForm(2);
        const validate_vehicle = validateVehicles();

        if(!vehicleData.length && index > 2){
            //console.log('vehicle validation')
            setActiveIndex(2)
            return toast.current.show({
                severity: 'error', 
                summary: 'Notice', 
                detail: 'Please add vehicle.', 
                life: 5000 
            });
        }

        if((Object.keys(validate_customer).length || validate_vehicle) && index > 2){
            setActiveIndex(2)
            return
        }

        setActiveIndex(index)
    }


    const shiftDepartureDate = (amount) => {
        const newDate = new Date(selectedDepartureDate);
        newDate.setDate(newDate.getDate() + amount);
        
        setSelectDepartureID(false)
        setSelectReturnID(false)

        //Trigger shifting
        const num = Math.floor(Math.random() * 100) + 1;
        setIsDepartureDateShifted(num)
        setIsReturnDateShifted(num)
        
        if (newDate >= today) {
            setSelectedDepartureDate(newDate); // Update local state
            setSelectedReturnDate(newDate);

            setDates((prev) => {
                return {
                    ...prev,
                    departure_date: newDate,
                    return_date: newDate
                };
            });
        }
    };


    const shiftReturnDate = (amount) => {
        const newDate = new Date(selectedReturnDate);
        newDate.setDate(newDate.getDate() + amount);

        setSelectReturnID(false)

        //Trigger shifting
        const num = Math.floor(Math.random() * 100) + 1;
        setIsDepartureDateShifted(num)
        
        if (newDate >= today) {
            setSelectedReturnDate(newDate); // Update local state
            //if (onChange) onChange(newDate); // Notify parent if needed

            setDates((prev) => {
                return {
                    ...prev,
                    //departure_date: newDate,
                    return_date: newDate
                };
            });
        }
    };

    const getTimeById = (id, type, props) => {
        const sched = scheduleOptions[type]

        if(!sched) return "---"

        const schedule = sched.find(item => item.id === id);

        const disp = helpers.formatTime(schedule[props])
        
        return schedule ? disp : "---";
    };

    const getDateById = (id, type, props) => {
        const sched = scheduleOptions[type]

        if(!sched) return "---"

        const schedule = sched.find(item => item.id === id);

        const disp = helpers.formatDateWithWeekDay(schedule[props])
        
        return schedule ? disp : "---";
    };

    // Formatter for the center display (e.g., 27 Apr 2026)
    const formatDisplayDate = (date) => {
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const handleSwap = () => {
        // We use a temporary variable or the functional state update to swap
        const tempFrom = tripOrigin;
        setTripOrigin(tripDestination);
        setTripDestination(tempFrom);
    };

    const handleEdit = () => {
        setActiveIndex(0)
        setSelectDepartureID(null)
        setSelectReturnID(null)
    };

    const formatTravelDate = (date, type = 'full') => {
        if (!date) return '';

        const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        const d = new Date(date);
        const dayName = days[d.getDay()];
        const monthName = months[d.getMonth()];
        const year = d.getFullYear();
        const dateNum = String(d.getDate()).padStart(2, '0');
        const monthNum = String(d.getMonth() + 1).padStart(2, '0');

        if (type === 'short') {
            // Returns: 04 / 27 / 2026
            return `${monthNum} / ${dateNum} / ${year}`;
        }

        // Returns: 2026 Apr 27 (MON)
        return `${year} ${monthName} ${dateNum} (${dayName})`;
    };

    const handleDepartureChange = (e) => {
        const newDeparture = e.value;
        
        setDates((prev) => {
            // Logic: If there's a return date and it's now before the new departure, clear it
            const shouldClearReturn = prev.return && newDeparture > prev.return;
            
            return {
                ...prev,
                departure_date: newDeparture,
                return_date: shouldClearReturn ? null : prev.return
            };
        });
        removeErrors(['departure_date']);
    };

    const removeErrors = (props) => {
        if (!props) return;
        
        // Convert a single string to an array so the logic works for both
        const propsToRemove = Array.isArray(props) ? props : [props];

        setErrors(prev => {
            const newErrors = { ...prev };
            propsToRemove.forEach(p => delete newErrors[p]);
            return newErrors;
        });
    };

    function handleSearch(){
        const validate = validateForm(activeIndex);
        if(Object.keys(validate).length){
            return
        }

        const {
            departure_date,
            return_date,
        } = tripDates

        //console.log('tripOrigin', tripOrigin)
        //console.log('tripDestination', tripDestination)

        const departureDate = helpers.formatDateSafe(departure_date)
        const returnDate = tripType === 'round-trip' ? helpers.formatDateSafe(return_date) : null

        setScheduleOptions([])
        setSelectDepartureID(false)
        setSelectReturnID(false)

        let filter = `?origin=${tripOrigin}&destination=${tripDestination}&departure_date=${departureDate}&`

        if(returnDate){
            filter += 'return_date='+returnDate+'&'
        }


        filter = filter.slice(0, -1)

        const url = helpers.createShipBookingHubUrl(`voyage/search${filter}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setScheduleOptions(res)
            setLoading(0)
            setActiveIndex(1)
        })
        .catch((err) => {
            setLoading(0)
            toast.current.show({
                severity: 'error', 
                summary: 'Notice', 
                detail: err.message, 
                life: 5000 
            });
        }); 
    }

    


    function handleProceed(){
        let isValid = false;
        if(activeIndex === 1){//Schedule
            if (tripType === 'round-trip') {
                if (!selectedDepartureID || !selectedReturnID) {
                    return toast.current.show({
                        severity: 'error', 
                        summary: 'Notice', 
                        detail: 'Please select both departure and return schedules.', 
                        life: 5000 
                    });
                }
            } else {
                // One-way validation
                if (!selectedDepartureID) {
                    return toast.current.show({
                        severity: 'error', 
                        summary: 'Notice', 
                        detail: 'Please select a departure schedule.', 
                        life: 5000 
                    });
                }
            }
            isValid = true
        }
        else if(activeIndex === 2){//Customer/Vehicle
            const validate = validateForm(activeIndex);
            const validate_vehicle = validateVehicles();

            if(!vehicleData.length){
                return toast.current.show({
                    severity: 'error', 
                    summary: 'Notice', 
                    detail: 'Please add vehicle.', 
                    life: 5000 
                });
            }

            if(Object.keys(validate).length || validate_vehicle){
                return
            }

            setVehicleErrors([])
            isValid = true
        }
        else if(activeIndex === 4){//Payment
            handleDone()
        }
        else{
            isValid = true
        }

        if (isValid) {
            setActiveIndex(prevIndex => prevIndex + 1);
        }
    }

    function handleDone(){
        //console.log([customerData, vehicleData])
        let formData = {
            customer_name: customerData.customer_name,
            customer_email: customerData.customer_email,
            customer_phone: customerData.customer_phone,
            customer_id: customerData.customer_id ?? '',
            notes: customerData?.notes,
            payment_method_id: selectedPaymentMethod,
            receipt_no: receiptNumber,
            save_customer: saveNewCustomer,
            split_payment: parseInt(selectedPaymentMethod) === 9 ? paymentRows : [],
            rebooked_from_booking_id: bookingDetails?.id ?? null,
        }

        let tripsData = []
        if(tripType === 'round-trip'){
            tripsData = [
                {
                    "trip_type": "departure",
                    "schedule_id": selectedDepartureID,
                    "items": vehicleData
                },
                {
                    "trip_type": "return",
                    "schedule_id": selectedReturnID,
                    "items": vehicleData
                },
            ]
            //tripsData.push()
        }
        else{//One-Way
            tripsData = [
                {
                    "trip_type": "one-way",
                    "schedule_id": selectedDepartureID,
                    "items": vehicleData
                },
            ]
        }

        formData.trips = tripsData
        const url = helpers.createShipBookingHubUrl(`booking`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)

        httpRequest(url, 'POST', {
            postdata: formData,
        }, true)
        .then((res) => {
            setLoading(0)
            //console.log(res)

            if(res.status === 'success'){
                //toast.current.show({severity:'success', detail:res.message, life: 10000});

                const {
                    id,
                    booking_ref
                } = res.data

                //const msg = `Booking details saved successfully. Booking Ref: ${booking_ref}.`

                //console.log('id', id)
                const title = booking_ref ? `Ref #: ${booking_ref}` : 'Confirmed'

                Swal.fire({
                    title: title,
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {;
                        window.location.replace(`/ship-booking/bookings/${id}`);
                        //return;
                    }
                })
            }  
            else{
                toast.current.show({severity:'error', detail:res.message, life: 10000});
            }
        })
        .catch((err) => {
            console.log(err)
            setLoading(0)
            toast.current.show({
                severity: 'error', 
                summary: 'Notice', 
                detail: err.message, 
                life: 5000 
            });
        }); 

        //console.log('formData', formData)
    }

    function handleBack(){
            setActiveIndex(activeIndex - 1)
    }
    


    const TripCard = ({ trip, isSelected, onSelect }) => {
        const {
            departure_time,
            estimated_arrival,
            origin,
            destination,
            duration_minutes,
            ship_name,

            //departureCode,
            //arrivalTime,
            //arrivalCode,
            //date,
            //eta,
            //classType,
            //price,
            //vesselCode
        } = trip;

        const convertToDecimalHours = (minutes) => {
            const hours = minutes / 60;
            // .toLocaleString handles the decimal point and rounding
            return `${hours.toLocaleString(undefined, { maximumFractionDigits: 1 })} hr/s`;
        };

        return (
            <div className="position-relative mb-3">
                {/* Red Checkmark Badge for Selected State */}
                {isSelected && (
                    <div className="position-absolute" style={{ top: '-10px', right: '-10px', zIndex: 10 }}>
                        <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center shadow" 
                            style={{ width: '28px', height: '28px', border: '2px solid white' }}>
                            <FaCheck size={12} color="white" />
                        </div>
                    </div>
                )}

                <div className={`card shadow-sm border-0 ${isSelected ? 'selected-trip-card' : ''}`} 
                    style={{ borderRadius: '8px', transition: 'all 0.2s ease' }}>
                    
                    {/* Red left-border indicator for Selected State */}
                    {isSelected && <div className="selected-indicator"></div>}

                    <div className="card-body py-4">

                        <div className="row align-items-center">
                            
                            {/* Departure Info */}
                            <div className="col-md-2">
                                <h5 className="font-weight-bold mb-0">{helpers.formatTime(departure_time)}</h5>
                                <div className="text-uppercase font-weight-bold small">{origin}</div>
                                <div className="text-muted small">{helpers.formatDateWithWeekDay(departure_time)}</div>
                            </div>

                            {/* ETA / Route Visual */}
                            <div className="col-md-5 text-center">
                                <div className="text-muted small mb-1">
                                        {ship_name}
                                </div>
                                <div className="d-flex align-items-center justify-content-center">
                                    <FaShip className="text-primary mr-2" />
                                    <div className="flex-grow-1 position-relative" style={{ borderTop: '2px dotted #ccc', minWidth: '100px' }}>
                                        <div className="position-absolute rounded-circle bg-warning" 
                                            style={{ width: '10px', height: '10px', right: '-5px', top: '-6px' }}></div>
                                    </div>
                                </div>
                                <div className="text-muted small mt-1">ETA {convertToDecimalHours(duration_minutes)}</div>
                            </div>

                            {/* Arrival Info */}
                            <div className="col-md-2">
                                <h5 className="font-weight-bold mb-0">{helpers.formatTime(estimated_arrival)}</h5>
                                <div className="text-uppercase font-weight-bold small">{destination}</div>
                                <div className="text-muted small">{helpers.formatDateWithWeekDay(estimated_arrival)}</div>
                            </div>

                            {/* Class and Price */}
                            {/* <div className="col-md-3 text-center">
                                <span className="badge badge-pill py-2 px-3 mb-2" 
                                    style={{ backgroundColor: '#fef3e3', color: '#f39c12', fontWeight: '600' }}>
                                    {classType}
                                </span>
                                <h4 className="font-weight-bold mb-0 text-dark">₱{price}</h4>
                            </div> */}

                            {/* Vessel Code */}
                            {/* <div className="col-md-2 text-muted small">
                                {ship_name}
                            </div> */}

                            {/* Action Button */}
                            <div className="col-md-3 text-right">
                                {isSelected ? (
                                    <Button label="Selected" className="p-button-dangers btn btn-primary px-4 rounded" 
                                            // style={{ backgroundColor: '#b71c1c', border: 'none' }}
                                            onClick={() => onSelect(null)} />
                                ) : (
                                    <Button label="Select" className="p-button-outlineds p-button-dangers btn btn-outline-primary px-4 rounded" 
                                            // style={{ borderColor: '#b71c1c', color: '#b71c1c' }}
                                            onClick={() => onSelect(trip.id)} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <style jsx>{`
                    .selected-trip-card {
                        border: 1px solid #007bff !important;
                    }
                    .selected-indicator {
                        position: absolute;
                        left: 0;
                        top: 0;
                        bottom: 0;
                        width: 5px;
                        background-color: #007bff;
                        border-top-left-radius: 8px;
                        border-bottom-left-radius: 8px;
                    }
                    .p-button:focus {
                        box-shadow: none !important;
                    }
                `}</style>
            </div>
        );
    };


    function handleCustomer(e){
        let data = {...customerData}

        setExitingCustomer(e)

        const address = e.address

        data.customer_id = e.id ?? ''
        data.contact_name = e.contact_name ?? ''
        data.customer_name = ""
        data.customer_phone = ""
        data.customer_email = ""
        data.notes = ""
        setContactData(data)
        setSameAsCustomer(false)
        setSelectedPaymentMethod(1)
    }

    function hadleResetCustomer(){
        let data = {...customerData}
        
        data.customer_id = ""
        data.contact_name = ""
        data.customer_name = ""
        data.customer_phone = ""
        data.customer_email = ""
        data.notes = ""
        setContactData(data)
        setSameAsCustomer(false)
        setSelectedPaymentMethod(1)
    }

    function hadleSameAsExistingCustomer(action = ''){
         const address = existingCustomer.address

        let data = {...customerData}
        data.customer_name = existingCustomer.contact_name ?? ''
        data.customer_email = existingCustomer.email ?? ''
        data.customer_phone = existingCustomer.phone_no ?? ''
        data.notes = customerData?.notes

        if(!action){
            data.customer_name = ""
            data.customer_phone = ""
            data.customer_email = ""
            data.notes = ""
        }
        setContactData(data)
        removeErrors(['customer_name', 'customer_email', 'customer_phone'])
    }
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        setContactData({ ...customerData, ...new_state });
        removeErrors(name)
    }

    const handleVehicleChange = (index, field, value) => {
        setVehicleData(prevVehicles => 
            prevVehicles.map((vehicle, i) => {
                // If the current map index matches our target index, update the object
                if (i === index) {
                    return { ...vehicle, [field]: value };
                }
                // Otherwise, return the vehicle as is
                return vehicle;
            })
        );
    };

    function hadleResetVehicle(index){
        const newValues = {
            "id": "",
            "vehicle_id": "",
            "item_type": "vehicle",
            "plate_number":"",
            "brand": "",
            "model_name": "",
            "year_model": "",
            "driver": "",
            "price": 0,
        }

        setVehicleData(prevVehicles => 
            prevVehicles.map((vehicle, i) => {
                if (i === index) {
                    // Merge existing vehicle data with the new JSON values
                    return { ...vehicle, ...defaultVehicleData };
                }
                return vehicle;
            })
        );
    }

    const removeVehicleRow = (index) => {
            setVehicleData(prevVehicles => 
                prevVehicles.filter((_, i) => i !== index)
            );
    };

    const onSelectVehicleItem = (event, index) => {
        handleVehicleChange(index, 'vehicle_id', event.value.id)
        handleVehicleChange(index, 'plate_number', event.value.plate_number)
        handleVehicleChange(index, 'brand', event.value.brand)
        handleVehicleChange(index, 'model_name', event.value.model_name)
    };

    const searchVehicle = (event) => {
        const query = event.query;

        if (!query || query.trim().length === 0) {
            setSuggestions([]); // This closes the dropdown and resets the list
            return; 
        }

        let filter = `?paginate=1&search=${query}&`

        filter = filter.slice(0, -1)

        const url = helpers.createShipBookingHubUrl(`vehicles${filter}`)

        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setSuggestions(res.data)

        })
        .catch((err) => {

        }); 
    };
   
    useEffect(() => {
        function handleSearchVehicle(index){
            setVehicleIndex(index)
            setVehicleModal(1)
        }

        const cards = vehicleData.map((vehicle, index) => {
            const errorEntry = vehicleErrors.find(e => e.index === index)?.errors;
            const { 
                vehicle_id, 
                plate_number, 
                brand, 
                model_name, 
                year_model, 
                existing_plate_number, 
                price,
                driver
            } = vehicle;

            const headerTemplate = (options) => {
                    const className = `${options.className} justify-content-space-between`;
                    return (
                        <div className={className}>
                            <div className="flex align-items-center gap-2">
                                <span className="font-bold">Vehicle{plate_number ? `: ${plate_number}`:''}{vehicle_id ? ` | Vehicle ID: ${vehicle_id}`: ''}</span>
                            </div>
                            <div>
                                <button type="button" className='btn btn-sm btn-danger mr-2'onClick={(e) => {
                                        e.stopPropagation(); // Prevents the panel from toggling when clicking delete
                                        removeVehicleRow(index);
                                }} ><i className='fas fa-trash'></i></button>
                                {options.togglerElement}
                            </div>
                        </div>
                    );
                };  

                    return (
                        <Panel headerTemplate={headerTemplate} className='mb-3' toggleable>
                            <div className="row mt-2">
                                <div className="col-lg-3 form-group">
                                    <label htmlFor={`plate-number-${index}`}>Plate Number<span className="text-danger">*</span></label>
                                    {/* <InputText
                                        id={`plate-number-${index}`} 
                                        name="plate_number" 
                                        value={plate_number || ""}
                                        tagClass="form-control mb-0"
                                        placeholder="Plate Number"
                                        onChange={(e) => handleVehicleChange(index, e.target.name, e.target.value.toUpperCase())}
                                        className='w-100'
                                        disabled={vehicle_id}
                                        //autocapitalize="characters"
                                    /> */}
                                    <AutoComplete 
                                        value={plate_number}
                                        name="plate_number"  
                                        suggestions={suggestions} 
                                        completeMethod={searchVehicle} 
                                        delay={1000}
                                        field="plate_number" // The property name to display if data is an object
                                        onSelect={(e) => onSelectVehicleItem(e, index)} // <--- Hook is here
                                        onChange={(e) => {
                                            handleVehicleChange(index, e.target.name, e.target.value)
                                            handleVehicleChange(index, 'vehicle_id', '')
                                        }}
                                        placeholder="Plate Number"
                                    />
                                    <RenderErrors 
                                        errors={errorEntry} 
                                        name="plate_number" 
                                        className="text-danger"
                                        style={{fontSize: '.9rem'}}
                                    />
                                </div>
                                <div className="col-lg-3 form-group">
                                    <label htmlFor={`brand-${index}`}>Brand<span className="text-danger">*</span></label>
                                    <InputText
                                        id={`brand-${index}`} 
                                        name="brand" 
                                        value={brand || ""}
                                        tagClass="form-control mb-0"
                                        placeholder="Brand"
                                        onChange={(e) => handleVehicleChange(index, e.target.name, e.target.value)}
                                        className='w-100'
                                    />
                                    <RenderErrors 
                                        errors={errorEntry} 
                                        name="brand" 
                                        className="text-danger"
                                        style={{fontSize: '.9rem'}}
                                    />
                                </div>
                                <div className="col-lg-3 form-group">
                                    <label htmlFor={`model-name-${index}`}>Model<span className="text-danger">*</span></label>
                                    <InputText
                                        id={`model-name-${index}`}
                                        name="model_name" 
                                        value={model_name || ""}
                                        tagClass="form-control mb-0"
                                        placeholder="Model"
                                        onChange={(e) => handleVehicleChange(index, e.target.name, e.target.value)}
                                        className='w-100'
                                    />
                                    <RenderErrors 
                                        errors={errorEntry} 
                                        name="model_name" 
                                        className="text-danger"
                                        style={{fontSize: '.9rem'}}
                                    />
                                </div>
                                <div className="col-lg-3 form-group">
                                    <label htmlFor={`price-${index}`}>Price<span className="text-danger">*</span></label>
                                    <InputNumber
                                        id={`price-${index}`} 
                                        name="price" 
                                        value={price || ""}
                                        tagClass="form-control mb-0"
                                        placeholder="Price"
                                        mode="currency" 
                                        currency="PHP" 
                                        locale="en-US" 
                                        //minFractionDigits={2} 
                                        maxFractionDigits={2} 
                                        onValueChange={(e) => handleVehicleChange(index, e.target.name, e.target.value)}
                                        className='w-100'
                                    />
                                    <RenderErrors 
                                        errors={errorEntry} 
                                        name="price" 
                                        className="text-danger"
                                        style={{fontSize: '.9rem'}}
                                    />
                                </div>
                                <div className="col-lg-6 form-group">
                                    <label htmlFor={`driver-${index}`}>Driver Names<span className="text-danger"></span></label>
                                    <InputText
                                        id={`driver-${index}`}
                                        name="driver" 
                                        value={driver || ""}
                                        tagClass="form-control mb-0"
                                        placeholder="Driver Names"
                                        onChange={(e) => handleVehicleChange(index, e.target.name, e.target.value)}
                                        className='w-100'
                                    />
                                    <RenderErrors 
                                        errors={errorEntry} 
                                        name="driver" 
                                        className="text-danger"
                                        style={{fontSize: '.9rem'}}
                                    />
                                </div>
                            </div>
                        </Panel>
                    );
            })
        setRenderVehicleCards(cards)
    }, [vehicleData, vehicleErrors, suggestions]);

    function handleSelectedVehicle(e){
        const newVehicle = {
            "id": "",
            "vehicle_id": e.id,
            "item_type": "vehicle",
            "plate_number": e.plate_number,
            "brand": e.brand,
            "model_name": e.model_name,
            "year_model": e.year_model,
            "price": 0,
            "driver": "",
        }

        setVehicleData(prevVehicles => [...prevVehicles, newVehicle]);
    }

    const addVehicleRow = () => {
        const newVehicle = {
            "id": "",
            "vehicle_id": "",
            "item_type": "vehicle",
            "plate_number":"",
            "brand": "",
            "model_name": "",
            "year_model": "",
            "driver": "",
            "price": 0,
        };

        // Append the new object to the existing array
        setVehicleData(prevVehicles => [...prevVehicles, defaultVehicleData]);
    };

    const RenderButtons = () => {
        return (
                <div className='d-flex justify-content-between mt-3 mb-5'>
                    <Button 
                        className="p-button-raiseds p-button-secondarys bg-whites border-0s text-dangers btn btn-light btn-lg w-100a text-center"
                        style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                        onClick={handleBack}
                    >
                        &larr; Back
                    </Button>

                    
                    {
                        parseInt(selectedPaymentMethod) === 9 && activeIndex === 4 ?

                        <Button 
                            className="p-button-raiseds p-button-secondarys bg-whites border-0s text-dangers btn btn-primary btn-lg w-100a text-center"
                            style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                            onClick={handleProceed}
                            disabled={!isSumPerfectMatch}
                        >
                            Done &#10003;
                        </Button>:

                        <Button 
                            className="p-button-raiseds p-button-secondarys bg-whites border-0s text-dangers btn btn-primary btn-lg w-100a text-center"
                            style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                            onClick={handleProceed}
                        >
                            { activeIndex === 4 ? <>Done &#10003;</> : <>Proceed &rarr;</>} 
                        </Button>
                    }

            </div>
        )
    }

    function getPortNameById(portId) {
        // Find the port object where the id matches
        const port = portList.find(p => p.id === portId);
        
        // Return the name if found, otherwise return a fallback message
        return port ? port.name : "N/A";
    }

    return (
        <>
        <Toast ref={toast} position="top-right" />
        <ContactListModal is_show={customerModal} setShow={setContactModal} handleSelect={handleCustomer} />

        <VehiclesSearchModal
            is_show={vehicleModal}
            setShow={setVehicleModal}
            index={vehicleIndex}
            handleSelect={handleSelectedVehicle}
         />

        <Layout page_title={page_title} menu={menu} parent_text="Manage Bookings" parent_link='/ship-booking/bookings' breadcrumbs={true}>
            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                {/* <h3>Starter Page Template</h3> */}

                <div className="container">

                    {/* PrimeReact Steps Component */}
                    <div className="mt-3 mb-5 custom-steps">
                        <Steps 
                            model={stepItems} 
                            activeIndex={activeIndex} 
                            //onSelect={(e) => setActiveIndex(e.index)} 
                            onSelect={handleStep}
                            readOnly={false} 
                        />
                    </div>

                    {/* Search Form*/}
                    {activeIndex === 0 && (
                    <div className="card shadow-sm border-0" >
                        <div className="card-body p-4 position-relative">
                            <div>
                                {/* Trip Type Selection */}
                                <div className="d-flex align-items-center mb-4">
                                    <div className="custom-control custom-radio d-flex align-items-center">
                                        <RadioButton inputId="oneWay" name="tripType" value="one-way" 
                                            onChange={(e) => setTripType(e.value)} checked={tripType === 'one-way'}  disabled={isRebooking}/>
                                        <label htmlFor="oneWay" className={`ml-2 mb-0 ${isRebooking ? ' text-muted' : ''}`}>One-way</label>
                                    </div>
                                    <div className="custom-control custom-radio mr-4 d-flex align-items-center">
                                        <RadioButton inputId="roundTrip" name="tripType" value="round-trip" 
                                            onChange={(e) => setTripType(e.value)} checked={tripType === 'round-trip'} disabled={isRebooking}/>
                                        <label htmlFor="roundTrip" className={`ml-2 mb-0 ${isRebooking ? ' text-muted' : ''}`}>Round Trip</label>
                                    </div>
                                </div>

                                {/* Location Dropdowns */}
                                <div className="form-row align-items-center mb-3">
                                    <div className="col-md-5">
                                        <div className="p-inputgroup bg-light border-0 rounded">
                                            <span className="p-inputgroup-addon bg-transparent border-0">
                                                {/* <i className="fa fas-map-marker text-muted"></i> */}
                                                <FaMapMarkerAlt />
                                            </span>
                                            <Dropdown 
                                                value={tripOrigin} 
                                                options={portList} 
                                                optionDisabled={(option) => option.id == tripDestination}
                                                onChange={(e) => {
                                                    setTripOrigin(e.value)
                                                    removeErrors('origin_location')
                                                }} 
                                                placeholder="From" 
                                                optionLabel="name" 
                                                optionValue="id" 
                                                filter 
                                                className="w-100 border-0 bg-transparent custom-dropdown"
                                            />
                                        </div>
                                        <RenderErrors 
                                            errors={errors} 
                                            name="origin_location" 
                                            className="text-danger"
                                            style={{fontSize: '.9rem'}}
                                        />
                                    </div>
                                    
                                    <div className="col-md-1 text-center py-2">
                                        {/* <i className="pi pi-arrows-h text-muted" style={{ fontSize: '1.2rem', cursor: 'pointer' }}></i> */}
                                        <FaExchangeAlt className='pointer' onClick={handleSwap} />
                                    </div>

                                    <div className="col-md-6">
                                        <div className="p-inputgroup bg-light border-0 rounded">
                                            <span className="p-inputgroup-addon bg-transparent border-0">
                                                {/* <i className="fa fas-map-marker text-muted"></i> */}
                                                <FaMapMarkerAlt />
                                            </span>
                                            <Dropdown 
                                                value={tripDestination} 
                                                options={portList} 
                                                optionDisabled={(option) => option.id == tripOrigin}
                                                onChange={(e) => {
                                                    setTripDestination(e.value)
                                                    removeErrors('destination_location')
                                                }} 
                                                optionLabel="name" 
                                                optionValue="id" 
                                                placeholder="To" 
                                                filter 
                                                className="w-100 border-0 bg-transparent custom-dropdown"
                                            />
                                        </div>
                                        <RenderErrors 
                                            errors={errors} 
                                            name="destination_location" 
                                            className="text-danger"
                                            style={{fontSize: '.9rem'}}
                                        />
                                    </div>
                                </div>

                                {/* Dates and Passengers */}
                                <div className="form-row align-items-end">
                                    <div className="col-md-4">
                                        {/* <label className="small mb-1 ml-1">Departure Date</label> */}
                                        <Calendar 
                                            value={tripDates.departure_date} 
                                            onChange={handleDepartureChange} 
                                            placeholder='Departure Date'
                                            minDate={today}
                                            showIcon 
                                            iconPos="right" 
                                            className="w-100 custom-calendar" 
                                            inputClassName="bg-light border-0 py-3" 
                                        />
                                        <RenderErrors 
                                            errors={errors} 
                                            name="departure_date" 
                                            className="text-danger"
                                            style={{fontSize: '.9rem'}}
                                        />
                                    </div>
                                    
                                    <div className="col-md-4">
                                        {/* <label className={`small mb-1 ml-1${tripType === 'one-way' ? ' text-muted' : ''}`}>Return Date</label> */}
                                        <Calendar 
                                            value={tripDates.return_date} 
                                            onChange={(e) => {
                                                setDates({...tripDates, return_date: e.value})
                                                removeErrors(['return_date']);
                                            }} 
                                            placeholder='Return Date'
                                            showIcon 
                                            iconPos="right" 
                                            className="w-100 custom-calendar" 
                                            inputClassName="bg-light border-0 py-3" 
                                            disabled={tripType === 'one-way'} 
                                            minDate={tripDates.departure_date}
                                        />
                                        <RenderErrors 
                                            errors={errors} 
                                            name="return_date" 
                                            className="text-danger"
                                            style={{fontSize: '.9rem'}}
                                        />
                                    </div>

                                    {/* <div className="col-md-3">
                                        <div className="p-inputgroup bg-light border-0 rounded" style={{ height: '54px', marginTop: '25px' }}>
                                            <span className="p-inputgroup-addon bg-transparent border-0"><FaTruck /></span>
                                            <div className="d-flex align-items-center px-2">1 Vehicle</div>
                                        </div>
                                    </div> */}

                                    <div className="col-md-1" />

                                    <div className="col-md-3 mt-3 mt-md-0">
                                        <button type='button' className="btn btn-danger btn-block py-3 font-weight-bold shadow-none" style={{ backgroundColor: '#007bff', border: 'none', height: '54px' }} onClick={handleSearch}>
                                            Search Trips
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                    {activeIndex > 0 && (
                    <div id="search-contaier" className="card shadow-sm border-0" >
                        <div className="card-body p-4 position-relative">
                            <div className="row align-items-center">
                                
                                {/* Departure Info */}
                                <div className="col-md-3 border-right-md">
                                    <p className="text-muted mb-0">Departure</p>
                                    <h5 className="font-weight-bold text-uppercase mb-0">
                                        {getPortNameById(tripOrigin)} <span className='small'>&rarr;</span> {getPortNameById(tripDestination)}
                                    </h5>
                                    <div className="small text-secondary">{formatTravelDate(tripDates.departure_date)}</div>
                                </div>

                                {/* Return Info */}

                                {tripType == 'round-trip' && (
                                <div className="col-md-3 border-right-md">
                                    <p className="text-muted mb-0">Return</p>
                                    <h5 className="font-weight-bold text-uppercase mb-0">
                                        {getPortNameById(tripDestination)} <span className='small'>&rarr;</span> {getPortNameById(tripOrigin)}
                                    </h5>
                                    <div className="small text-secondary">{formatTravelDate(tripDates.return_date)}</div>
                                </div>)}

                                {/* Passenger Info */}
                                <div className={`${tripType === 'round-trip' ? 'col-md-3' : 'col-md-6'}`}>
                                    <p className="text-muted mb-0">Vehicle(s)</p>
                                    <div className="font-weight-bold">
                                        {vehicleData.length}
                                    </div>
                                </div>

                                {/* Edit Action */}
                                <div className="col-md-3 text-right">
                                    <Button 
                                        onClick={handleEdit}
                                        className="p-button-outlineds p-button-dangers edit-trip-btn btn btn-outline-danger"
                                    >
                                        <FaEdit className="mr-2" />
                                        <span className="font-weight-bold">Edit Trip</span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                    {/* Schedules */}
                    {activeIndex === 1 && (
                    <div id="schedule-container" className='row mt-5 d-flex justify-content-between'>
                            <div className="col-lg-8">
                                <div id="departure-container" className='mb-3'>
                                    <label className='text-muted small mb-0'>Departure</label>
                                    <h4 class="font-weight-bold text-uppercase">{getPortNameById(tripOrigin)} <span className='text-primary'>&rarr;</span> {getPortNameById(tripDestination)}</h4>                            

                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                        
                                        {/* Previous Day Button */}
                                        <Button 
                                            className="p-button-raised p-button-secondary bg-white border-0 text-danger"
                                            onClick={() => shiftDepartureDate(-1)}
                                            disabled={isPrevDisabled}
                                            style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                        >
                                            <FaChevronLeft className="mr-2" />
                                            <span className="font-weight-bold">Prev. Day</span>
                                        </Button>

                                        {/* Current Date Display */}
                                        <div className="d-flex align-items-center bg-white px-4 py-2 rounded-pill shadow-sm border">
                                            <FaCalendarAlt className="text-primary mr-3" size={18} />
                                            <span className="font-weight-bold text-dark" style={{ fontSize: '1.1rem' }}>
                                                {formatDisplayDate(selectedDepartureDate)}
                                            </span>
                                        </div>

                                        {/* Next Day Button */}
                                        <Button 
                                            className="p-button-raised p-button-secondary bg-white border-0 text-danger"
                                            onClick={() => shiftDepartureDate(1)}
                                            style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                        >
                                            <span className="font-weight-bold">Next Day</span>
                                            <FaChevronRight className="ml-2" />
                                        </Button>

                                    </div>
                                    
                                    {/* <div className='mt-5'>
                                        <div className='card shadow-sm border-0'>
                                            <div className="card-body p-4 position-relative">
                                                a
                                            </div>
                                        </div>
                                    </div> */}

                                    
                                    <div className='mt-4'>
                                        {scheduleOptions?.departure_schedules?.map(trip => (
                                            <TripCard 
                                                key={trip.id} 
                                                trip={trip} 
                                                isSelected={selectedDepartureID === trip.id} 
                                                onSelect={(id) => {
                                                    setDates({...tripDates, departure_date: selectedDepartureDate, return_date: selectedReturnDate})
                                                    setSelectDepartureID(id)
                                                    setSelectReturnID(false)
                                                }} 
                                            />
                                        ))}
                                        {!scheduleOptions?.departure_schedules?.length && (
                                            <div class="alert alert-info text-center" role="alert">
                                            No available schedule
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {tripType === 'round-trip' && (
                                <div id="return-container" className='mt-5'>
                                    <label className='text-muted small mb-0'>Return</label>
                                    <h4 class="font-weight-bold text-uppercase">{getPortNameById(tripDestination)} <span className='text-primary'>&rarr;</span> {getPortNameById(tripOrigin)}</h4>                            

                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                        
                                        {/* Previous Day Button */}
                                        <Button 
                                            className="p-button-raised p-button-secondary bg-white border-0 text-danger"
                                            onClick={() => shiftReturnDate(-1)}
                                            disabled={isPrevReturnDisabled}
                                            style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                        >
                                            <FaChevronLeft className="mr-2" />
                                            <span className="font-weight-bold">Prev. Day</span>
                                        </Button>

                                        {/* Current Date Display */}
                                        <div className="d-flex align-items-center bg-white px-4 py-2 rounded-pill shadow-sm border">
                                            <FaCalendarAlt className="text-primary mr-3" size={18} />
                                            <span className="font-weight-bold text-dark" style={{ fontSize: '1.1rem' }}>
                                                {formatDisplayDate(selectedReturnDate)}
                                            </span>
                                        </div>

                                        {/* Next Day Button */}
                                        <Button 
                                            className="p-button-raised p-button-secondary bg-white border-0 text-danger"
                                            onClick={() => shiftReturnDate(1)}
                                            style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                        >
                                            <span className="font-weight-bold">Next Day</span>
                                            <FaChevronRight className="ml-2" />
                                        </Button>

                                    </div>

                                    
                                    <div className='mt-4'>
                                        {scheduleOptions?.return_schedules?.map(trip => (
                                            <TripCard 
                                                key={trip.id} 
                                                trip={trip} 
                                                isSelected={selectedReturnID === trip.id} 
                                                onSelect={(id) => {
                                                    setDates({...tripDates, return_date: selectedReturnDate})
                                                    setSelectReturnID(id)
                                                }} 
                                            />
                                        ))}
                                        {!scheduleOptions?.return_schedules?.length && (
                                            <div class="alert alert-info text-center" role="alert">
                                            No available schedule
                                            </div>
                                        )}
                                    </div>
                                </div>)}
                            </div>
                            <div className="col-lg-4 mt-lg-5">
                                <div className='card shadow-sm border-0'>
                                    <div className="card-body p-4 position-relative">
                                        <div>
                                            <h4 className='font-weight-bold mb-3'>Departure</h4>
                                            {selectedDepartureID ?
                                            <>
                                            {/* <p className='text-muted text-sm mb-0'>{formatDisplayDate(tripDates.departure_date)}</p> */}
                                            <div className='d-flex justify-content-between mt-4 mb-3'><h5>{getPortNameById(tripOrigin)}</h5> <span className='text-primary'>&rarr;</span> <h5>{getPortNameById(tripDestination)}</h5></div>
                                            <div className='d-flex justify-content-between'>
                                                <div>
                                                    <p className='text-muted text-sm mb-0'>Departure</p>
                                                    <h5 className='mb-0'>{getTimeById(selectedDepartureID, 'departure_schedules', 'departure_time')}</h5>
                                                    {/* {formatDisplayDate(tripDates.departure_date)} */}
                                                    <p className='mb-0'>{getDateById(selectedDepartureID, 'departure_schedules', 'departure_time')}</p>
                                                </div>
                                                <div>
                                                    <p className='text-muted text-sm mb-0'>Arrival</p>
                                                    <h5 className='mb-0'>{getTimeById(selectedDepartureID, 'departure_schedules', 'estimated_arrival')}</h5>
                                                    <p className='mb-0'>{getDateById(selectedDepartureID, 'departure_schedules', 'estimated_arrival')}</p>
                                                </div>
                                            </div></> : 
                                            <p className='mb-0 text-danger'>Select departure schedule to continue booking</p>
                                            }
                                        </div>
                                        {tripType === 'round-trip' && (
                                        <>
                                        <hr />
                                        <div>
                                            <h4 className='font-weight-bold mb-3'>Return</h4>
                                            {selectedReturnID ?
                                            <>
                                            {/* <p className='text-muted text-sm mb-0'>{formatDisplayDate(tripDates.return_date)}</p> */}
                                            <div className='d-flex justify-content-between mt-4 mb-3'><h5>{getPortNameById(tripDestination)}</h5> <span className='text-primary'>&rarr;</span> <h5>{getPortNameById(tripOrigin)}</h5></div>
                                            <div className='d-flex justify-content-between'>
                                                <div>
                                                    <p className='text-muted text-sm mb-0'>Departure</p>
                                                    <h5 className='mb-0'>{getTimeById(selectedReturnID, 'return_schedules', 'departure_time')}</h5>
                                                    <p className='mb-0'>{getDateById(selectedReturnID, 'return_schedules', 'departure_time')}</p>
                                                </div>
                                                <div>
                                                    <p className='text-muted text-sm mb-0'>Arrival</p>
                                                    <h5 className='mb-0'>{getTimeById(selectedReturnID, 'return_schedules', 'estimated_arrival')}</h5>
                                                    <p className='mb-0'>{getDateById(selectedReturnID, 'return_schedules', 'estimated_arrival')}</p>
                                                </div>
                                            </div></> : 
                                            <p className='mb-0 text-danger'>Select return schedule to continue booking</p>
                                            }
                                        </div>
                                        </>
                                        )}
                                    </div>
                                </div>

                                
                                <Button 
                                    className="p-button-raiseds p-button-secondarys bg-whites border-0s text-dangers btn btn-primary btn-lg w-100 text-center"
                                    style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                    onClick={handleProceed}
                                >
                                    Proceed &rarr;
                                </Button>
                            </div>
                    </div>
                    )}

                    {/* Contact/Vehicle */}
                    {activeIndex === 2 && (
                    <div id="vehicle-container" className='rows mt-5 d-flexs justify-content-betweens'>
                        <div id="contact-container">
                            <h5 class="font-weight-bold text-uppercase mb-3">Contact Details</h5>  

                            <div className='card shadow-sm border-0'>
                                <div className="card-body p-4 position-relative">
                                    <div className="row d-flexs justify-content-betweens">
                                        <div className="col-lg-4">
                                            <label className='mb-0'>Linked Customer</label>
                                            <p className='mb-3 small text-muted'>(Linked customer is required for “Invoice Payment”)</p>
                                            <div className="p-inputgroup flex-1">
                                                <InputText 
                                                    placeholder="Select Customer"
                                                    onClick={(e) => setContactModal(1)}
                                                    onChange={(e) => setContactModal(1)}
                                                    value={customerData.contact_name} 
                                                    placeholder="Search Existing Customer"
                                                    //disabled={customer_id ? true : false}
                                                />
                                                <Button 
                                                    icon="fas fa-search" 
                                                    className="p-button-primary" 
                                                    type="button"
                                                    onClick={(e) => setContactModal(1)}
                                                    //disabled={customer_id ? true : false}
                                                />
                                            </div>
                                            <RenderErrors 
                                                errors={errors} 
                                                name="customer_id" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                        
                                        {customerData.customer_id && (
                                        <div className="col-lg-3 d-flex justify-content-ends align-items-end">
                                            <Button 
                                                //icon="fas fa-search" 
                                                className="btn btn-outline-primary mt-3 mt-lg-0" 
                                                style={{padding: '0.75rem 1rem'}}
                                                type="button"
                                                label='Reset'
                                                onClick={hadleResetCustomer}
                                            />
                                        </div>)}
                                    </div>
                                    <hr/>
                                    <div className="row mt-2">
                                        {customerData.customer_id && (
                                        <div className="col-lg-2">
                                            <label>ID</label>
                                            <InputText
                                                value={customerData.customer_id}
                                                className="mb-0 w-100"
                                                placeholder="Contact ID"
                                                disabled
                                            />
                                            <RenderErrors 
                                                errors={errors} 
                                                name="width" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>)}
                                        <div className="col-lg-4 form-group">
                                            <label htmlFor='customer_name'>Name<span className="text-danger">*</span></label>
                                            <InputText
                                                id="customer_name" 
                                                name="customer_name" 
                                                value={customerData.customer_name}
                                                tagClass="form-control mb-0"
                                                placeholder="Contact Name"
                                                onChange={inputChange}
                                                className='w-100'
                                            />
                                            <RenderErrors 
                                                errors={errors} 
                                                name="customer_name" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                        <div className="col-lg-3 form-group">
                                            <label htmlFor='customer_phone'>Phone No<span className="text-danger"></span></label>
                                            <InputMask 
                                                id="customer_phone" 
                                                name="customer_phone" 
                                                mask="9999-999-9999" 
                                                value={customerData.customer_phone}
                                                placeholder="09XX-XXX-XXXX"
                                                onChange={inputChange}
                                                className='w-100'
                                            />
                                            <RenderErrors 
                                                errors={errors} 
                                                name="customer_phone" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                        <div className="col-lg-3">
                                            <label htmlFor='customer_email'>Email</label>
                                            <InputText
                                                id="customer_email" 
                                                name="customer_email" 
                                                type="email"
                                                keyfilter="email"
                                                value={customerData.customer_email}
                                                tagClass="form-control mb-0"
                                                placeholder="Email"
                                                onChange={inputChange}
                                                className='w-100'
                                            />
                                            <RenderErrors 
                                                errors={errors} 
                                                name="customer_email" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                        <div className="col-lg-12">
                                            <label htmlFor='customer_name'>Notes <small>(optional)</small></label>
                                            <InputTextarea
                                                id="notes" 
                                                name="notes" 
                                                placeholder="Optional Notes" 
                                                value={customerData.notes} 
                                                tagClass="form-control w-100"
                                                onChange={inputChange}
                                                rows={2}
                                                maxLength={500} 
                                                className='w-100'
                                            />
                                            <RenderErrors 
                                                errors={errors} 
                                                name="notes" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                    </div>
                                    {/* {!customerData.customer_id && (
                                    <div className="d-flex align-items-center mt-3">
                                        <InputSwitch 
                                            inputId="notifications" 
                                            checked={saveNewCustomer} 
                                            onChange={(e) => setSaveNewCustomer(e.value)} 
                                        />
                                        <label htmlFor="notifications" className="ml-2 m-0 font-weight-normal">Save Profile for Future Customers</label>
                                    </div>)} */}
                                    {customerData.customer_id && (
                                    <div className="d-flex align-items-center mt-3">
                                        <InputSwitch 
                                            inputId="same_customer" 
                                            checked={sameAsCustomer} 
                                            onChange={(e) => {
                                                setSameAsCustomer(e.value)
                                                hadleSameAsExistingCustomer(e.value)
                                            }} 
                                        />
                                        <label htmlFor="same_customer" className="ml-2 m-0 font-weight-normal">Same as existing customer details</label>
                                    </div>)}
                                </div>
                            </div>
                        </div>

                        <div id="vehicle-container" className='mt-5'>
                            <div className='d-flex flex-column flex-md-row align-items-md-center justify-content-md-between mb-4'>
                                <h5 class="font-weight-bold text-uppercase mb-0">Vehicle Details</h5>  
                                <div>
                                    {/* <button className='btn btn-sms btn-primary mr-2' type='button' onClick={() => setVehicleModal(1)}>Add Existing Vehicle</button> */}
                                    <button className='btn btn-sms btn-primary' type='button' onClick={addVehicleRow}>Add Vehicle</button>
                                </div>
                            </div>
                            {
                                renderVehicleCards
                            }
                        </div>

                        <RenderButtons />
                    </div>
                    )}

                    {activeIndex === 3 && (
                    <div id="review-container" className='row mt-5'>
                        <div className='col-lg-8 mb-5 mb-md-0'>
                            <div className='trip-summary mb-5'>
                                <h5 class="font-weight-bold text-uppercase mb-3">Trip Summary</h5> 
                                
                                <div className="departure border-0 rounded bg-white shadow-sm p-5">
                                    <p class="text-muted mb-0">Departure</p>

                                    <div className="row align-items-center form-group">
                                        <div className="col-md-4">
                                            <div className='d-flex justify-content-start'>
                                                <h4>{getPortNameById(tripOrigin)}</h4> 
                                                <span className='text-primary mx-2'>&rarr;</span> 
                                                <h4>{getPortNameById(tripDestination)}</h4>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <p class="text-muted mb-0">Departure Date</p>
                                            <h5>{formatTravelDate(tripDates.departure_date)}</h5>
                                        </div>
                                        <div className="col-lg-6">
                                            <p class="text-muted mb-0">Travel Time</p>
                                            <h5>{getTimeById(selectedDepartureID, 'departure_schedules', 'departure_time')} - {getTimeById(selectedDepartureID, 'departure_schedules', 'estimated_arrival')}</h5>
                                        </div>
                                    </div>

                                    {/* <hr className='my-4'/> */}
                                </div>
                                
                                {tripType === 'round-trip' && (
                                <div className="departure border-0 rounded bg-white shadow-sm p-5 mt-3">
                                    <p class="text-muted mb-0">Return</p>

                                    <div className="row align-items-center form-group">
                                        <div className="col-md-4">
                                            <div className='d-flex justify-content-start'>
                                                <h4>{getPortNameById(tripDestination)}</h4> 
                                                <span className='text-primary mx-2'>&rarr;</span> 
                                                <h4>{getPortNameById(tripOrigin)}</h4>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <p class="text-muted mb-0">Departure Date</p>
                                            <h5>{formatTravelDate(tripDates.return_date)}</h5>
                                        </div>
                                        <div className="col-lg-6">
                                            <p class="text-muted mb-0">Travel Time</p>
                                            {/* <h5>{getTimeById(selectedReturnID)} - {getTimeById(selectedReturnID, 'arrivalTime')}</h5> */}
                                            <h5>{getTimeById(selectedReturnID, 'return_schedules', 'departure_time')} - {getTimeById(selectedReturnID, 'return_schedules', 'estimated_arrival')}</h5>
                                        </div>
                                    </div>
                                </div>)}
                            </div>

                            <div className='contact-information mb-5'>
                                <h5 class="font-weight-bold text-uppercase mb-3">Contact Information</h5> 
                                
                                <div className="departure border-0 rounded bg-white shadow-sm p-5">
                                    <div className="row">
                                        <div className="col-lg-4 mb-3 mb-md-0">
                                            <p class="text-muted mb-0">Name</p>
                                            <p className='mb-0'>{customerData.customer_name}</p>
                                        </div>
                                        <div className="col-lg-4 mb-3 mb-md-0">
                                            <p class="text-muted mb-0">Phone No.</p>
                                            <p className='mb-0'>{customerData.customer_phone}</p>
                                        </div>
                                        <div className="col-lg-4">
                                            <p class="text-muted mb-0">Email</p>
                                            <p className='mb-0'>{customerData.customer_email}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='contact-information'>
                                <h5 class="font-weight-bold text-uppercase">Vehicle Information</h5> 

                                {vehicleData.map((vehicle, index) => {
                                    return (
                                            <div className="departure border-0 rounded bg-white shadow-sm p-5 mt-3">
                                                <div className="row">
                                                    <div className="col-lg-4 mb-3 mb-md-0">
                                                        <p class="text-muted smalls mb-0">Plate Number</p>
                                                        <p className='mb-0'>{vehicle.plate_number}</p>
                                                    </div>
                                                    <div className="col-lg-4 mb-3 mb-md-0">
                                                        <p class="text-muted smalls mb-0">Brand</p>
                                                        <p className='mb-0'>{vehicle.brand}</p>
                                                    </div>
                                                    <div className="col-lg-4 mb-3">
                                                        <p class="text-muted smalls mb-0">Model</p>
                                                        <p className='mb-0'>{vehicle.model_name}</p>
                                                    </div>
                                                    <div className="col-lg-4 mb-3">
                                                        <p class="text-muted smalls mb-0">Driver(s)</p>
                                                        <p className='mb-0'>{vehicle.driver ? vehicle.driver : '---'}</p>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <p class="text-muted smalls mb-0">Price</p>
                                                        <p className='mb-0'>₱ {helpers.formatAmount(vehicle.price)}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                })}
                            </div>
                        </div>

                        <div className='col-lg-4'>
                            <h5 class="font-weight-bold text-uppercase mb-3">Booking Fee</h5> 
                            <div className="departure border-0 rounded bg-white shadow-sm p-5">
                                <div className='d-flex justify-content-between mb-2 text-muted'>
                                    <div>Vehicle(s) x {vehicleData.length}</div>
                                    <div>₱ {helpers.formatAmount(computeTotalPrice())}</div>
                                </div>
                                <div className='d-flex justify-content-between text-muted'>
                                    <div>Trip(s)</div>
                                    <div>{tripType === 'round-trip' ? 2 : 1}</div>
                                </div>
                                {/* <div className='d-flex justify-content-between text-muted'>
                                    <div>Other Fee</div>
                                    <div>₱ 0.00</div>
                                </div> */}
                                <hr/>
                                <div>
                                    <span>Total Amount</span>
                                    <h3 className='text-right mb-0 font-weight-bold'>₱ {helpers.formatAmount(computeTotalAmount())}</h3>
                                </div>
                            </div>

                            <RenderButtons />
                        </div>
                    </div>
                    )}

                    
                    {/* Payment Selection */}
                    {activeIndex === 4 && (
                    <div id="payment-container" className='row mt-5 d-flexs justify-content-betweens'>
                        
                        <div className='col-lg-8'>
                            <h5 class="font-weight-bold text-uppercase mb-3">Payment Method</h5> 
                            <div className="border rounded bg-white shadow-sm mb-4">
                                {paymentMethodOptions.map((method, index) => {

                                        //console.log('customerData.customer_id', customerData.customer_id)
                                        //console.log('customerData.customer_id', customerData.customer_id)
                                        const disableInvoice = parseInt(method.id) === 8 &&
                                                                (!customerData?.customer_id || customerData.customer_id === "");

                                                                //console.log('disableInvoice: ' + method.method_name,  disableInvoice)

                                        return (
                                            <div key={method.id} className={index !== paymentMethodOptions.length - 1 ? 'border-bottom' : ''}>
                                                {/* Row Header */}
                                                <div
                                                    className="d-flex align-items-center p-4"
                                                    style={{
                                                        cursor: disableInvoice ? 'not-allowed' : 'pointer',
                                                        opacity: disableInvoice ? 0.6 : 1
                                                    }}
                                                    onClick={() => {
                                                        if (!disableInvoice) {
                                                            setSelectedPaymentMethod(method.id);
                                                        }
                                                    }}
                                                >
                                                    <RadioButton 
                                                        inputId={`method_${method.id}`} 
                                                        name="payment" 
                                                        value={method.id} 
                                                        onChange={(e) => setSelectedPaymentMethod(e.value)} 
                                                        checked={selectedPaymentMethod === method.id} 
                                                        disabled={disableInvoice}
                                                    />
                                                    <label 
                                                        htmlFor={`method_${method.id}`} 
                                                        className="ml-3 mb-0 flex-grow-1 font-weight-bold"
                                                        style={{
                                                            cursor: disableInvoice ? 'not-allowed' : 'pointer'
                                                        }}
                                                    >
                                                        {method.icon}
                                                        {method.method_name}
                                                    </label>

                                                    <p className="text-muted d-block mb-0 text-sm">{method.id === 8 ? '*Required Linked Customer' : ''}</p>
                                                </div>

                                                {/* Conditional Input for Cash (Method ID 1) */}
                                                {parseInt(selectedPaymentMethod) === method.id && (method.id !== 8 && method.id !== 9) && (
                                                    <div className="px-5 pb-3 animate__animated animate__fadeIn">
                                                        <div className="p-inputgroup col-md-6 p-0">
                                                            <span className="p-inputgroup-addon"><FaReceipt  /></span>
                                                            <InputText 
                                                                placeholder="Transaction ID / Ref" 
                                                                value={receiptNumber} 
                                                                onChange={(e) => setReceiptNumber(e.target.value)} 
                                                                autoFocus
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Conditional Input for Cash (Method ID 1) */}
                                                {parseInt(selectedPaymentMethod) === 9 && parseInt(method.id) === 9 && (
                                                    <div className="px-5 pb-3 animate__animated animate__fadeIn">

                                                        {/* 1. Wrap the entire iteration group in a standard grid row container */}
                                                        <div className="row">
                                                            {paymentRows.map((row, index) => (
                                                                <div key={row.id} className="col-md-6 col-sm-6 mb-4 d-flex">
                                                                    {/* d-flex ensures all cards in a row stretch to match the tallest one perfectly */}
                                                                    <div className="card shadow-sm border p-3 bg-light w-100 position-relative animate__animated animate__fadeIn" style={{ borderRadius: '12px' }}>
                                                                        
                                                                        {/* Header Section inside Card: Shows Payment # and Delete action */}
                                                                        <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                                                                            <span className="font-weight-bold text-secondary small text-uppercase tracking-wider">
                                                                                Allocation #{index + 1}
                                                                            </span>
                                                                            
                                                                            {paymentRows.length > 1 && (
                                                                                <Button 
                                                                                    type="button"
                                                                                    icon="fas fa-trash" 
                                                                                    className="p-button-danger p-button-text text-danger p-0"
                                                                                    onClick={() => removeRow(row.id)} 
                                                                                    tooltip="Remove allocation"
                                                                                    tooltipOptions={{ position: 'top' }}
                                                                                    style={{ height: '24px', width: '24px' }}
                                                                                />
                                                                            )}
                                                                        </div>

                                                                        {/* Form Fields - Stacked neatly inside the card layout block */}
                                                                        <div className="d-flex flex-column gap-3">
                                                                            
                                                                            {/* 1. Method Dropdown */}
                                                                            <div className="form-group mb-2">
                                                                                <label className="font-weight-bold text-muted small mb-1">Split Method</label>
                                                                                <Dropdown 
                                                                                    value={row.method} 
                                                                                    options={methodOptions} 
                                                                                    onChange={(e) => updateRowValue(row.id, 'method', e.value)} 
                                                                                    optionDisabled={(option) => 
                                                                                        paymentRows.some(pRow => pRow.method === option.value && pRow.id !== row.id)
                                                                                    }
                                                                                    placeholder="Select Method"
                                                                                    className="w-100 bg-white"
                                                                                    optionLabel="method_name" // Set to use method_name
                                                                                    optionValue="id"          // Set to use id
                                                                                />
                                                                            </div>
                                                                            
                                                                            {/* 2. Adaptive Reference Details Input */}
                                                                            <div className="form-group mb-2">
                                                                                <label className="font-weight-bold text-muted small mb-1">Reference Details</label>
                                                                                <InputText
                                                                                    value={row.reference_no}
                                                                                    onChange={(e) => updateRowValue(row.id, 'reference_no', e.target.value)}
                                                                                    placeholder={
                                                                                        row.method === 1 ? "Sales Invoice No" : 
                                                                                        row.method === 4 ? "Check Number" : 
                                                                                        "Transaction ID / Ref"
                                                                                    }
                                                                                    className="w-100 bg-white"
                                                                                    disabled={!row.method}
                                                                                />
                                                                            </div>
                                                                            
                                                                            {/* 3. Amount Field Allocation */}
                                                                            <div className="form-group mb-0">
                                                                                <label className="font-weight-bold text-muted small mb-1">Amount</label>
                                                                                {/* <div className="position-relative">
                                                                                    <span className="position-absolute font-weight-bold text-muted bg-light" style={{ left: '14px', right: '14px', top: '50%', transform: 'translateY(-50%)', zIndex: 5 }}>
                                                                                        ₱
                                                                                    </span>
                                                                                    <InputNumber 
                                                                                        value={row.amount} 
                                                                                        onValueChange={(e) => updateRowValue(row.id, 'amount', e.value)} 
                                                                                        mode="decimal" 
                                                                                        minFractionDigits={2} 
                                                                                        maxFractionDigits={2} 
                                                                                        placeholder="0.00"
                                                                                        className="w-100"
                                                                                        inputClassName="w-100"
                                                                                        style={{ paddingLeft: '24px' }}
                                                                                    />
                                                                                </div> */}
                                                                                <div className="p-inputgroup flex-1">
                                                                                    <span className="p-inputgroup-addon">
                                                                                        ₱
                                                                                    </span>
                                                                                    <InputNumber 
                                                                                        value={row.amount} 
                                                                                        onValueChange={(e) => updateRowValue(row.id, 'amount', e.value)} 
                                                                                        mode="decimal" 
                                                                                        minFractionDigits={2} 
                                                                                        maxFractionDigits={2} 
                                                                                        placeholder="0.00"
                                                                                        className="w-100"
                                                                                        inputClassName="w-100"
                                                                                        // style={{ paddingLeft: '24px' }}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {/* Form Actions Footnote Utility Elements */}
                                                        <div className="flex justify-content-between border-top-1 border-200">
                                                            <Button 
                                                                type="button" 
                                                                label="Add Split Method" 
                                                                icon="pi pi-plus" 
                                                                outlined 
                                                                severity="secondary" 
                                                                onClick={addNewRow} 
                                                                disabled={balanceRemaining <= 0} // Blocks extra splits if balance is fully paid
                                                                className="p-button-sm rounded mr-3"
                                                            />
                                                            
                                                            {/* <Button 
                                                                type="button" 
                                                                label="Finalize Multi-Payment" 
                                                                icon="pi pi-check-circle" 
                                                                severity="success" 
                                                                disabled={!isSumPerfectMatch} // Locks submission until balance reads exactly 0.00
                                                                onClick={() => console.log("Payload finalized and safe for transmission:", paymentRows)}
                                                                className="p-button-sm px-4 rounded"
                                                            /> */}
                                                        </div>

                                                    </div>
                                                )}
                                                
                                            </div>
                                        );
                                    }
                                )}
                            </div>
                        </div>

                        <div className='col-lg-4'>
                            <h5 class="font-weight-bold text-uppercase mb-3">Payment Summary</h5> 
                            <div className="departure border-0 rounded bg-white shadow-sm p-5">
                                <div className='d-flex justify-content-between mb-2 text-muted'>
                                    <div>Vehicle(s) x 2</div>
                                    <div>₱ {helpers.formatAmount(computeTotalPrice())}</div>
                                </div>
                                <div className='d-flex justify-content-between text-muted'>
                                    <div>Trip(s)</div>
                                    <div>{tripType === 'round-trip' ? 2 : 1}</div>
                                </div>
                                {/* <div className='d-flex justify-content-between text-muted'>
                                    <div>Other Fee</div>
                                    <div>₱ 0.00</div>
                                </div> */}
                                <hr/>
                                <div>
                                    <span>Total Amount</span>
                                    <h3 className='text-right mb-0 font-weight-bold'>₱ {helpers.formatAmount(computeTotalAmount())}</h3>
                                </div>
                            </div>

                            <RenderButtons />
                        </div>
                    </div>
                    )}

                    
                    {/* {activeIndex > 1 && (
                        <div className='d-flex justify-content-between mt-5 mb-5'>
                                <Button 
                                    className="p-button-raiseds p-button-secondarys bg-whites border-0s text-dangers btn btn-light btn-lg w-100a text-center"
                                    style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                    onClick={handleBack}
                                >
                                    &larr; Back
                                </Button>


                                <Button 
                                    className="p-button-raiseds p-button-secondarys bg-whites border-0s text-dangers btn btn-primary btn-lg w-100a text-center"
                                    style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                    onClick={handleProceed}
                                >
                                    Proceed &rarr;
                                </Button>

                        </div>
                    )} */}

                </div>

            </div>
        </Layout>
        </>
    )
}